import React from 'react';
import '../../../styles/header.css';
import { Grid } from '@mui/material';

function HeaderIcetex() {
    return (
        <>
            <div className="cont header-icetex">
                <nav
                    className="navbar navbar-expand-lg barra-superior-govco"
                    aria-label="Barra superior"
                >
                    <a
                        href="https://www.gov.co/"
                        target="_blank"
                        aria-label="Portal del Estado Colombiano - GOV.CO"
                    ></a>
                </nav>
                <Grid
                    container
                    className="container-fluid bg-oscuro"
                    columns={{ xs: 6, sm: 12, md: 12 }}
                >
                    <Grid item xs={4} sm={4} md={4}>
                        <a
                            className="logo custom-logo align-items-center"
                            href="https://web.icetex.gov.co"
                            title="Ir a ICETEX"
                        >
                            <img
                                alt="ICETEX"
                                className="my-3 logo-colombia"
                                height="60"
                            />
                        </a>
                    </Grid>
                    <Grid item xs={7} sm={7} md={7} className="text-center">
                        <Grid
                            container
                            spacing={2}
                            columns={{ xs: 6, sm: 6, md: 12 }}
                        >
                            <Grid
                                item
                                xs={6}
                                sm={6}
                                md={6}
                                className="container-btn-icetex"
                            >
                                <a
                                    className="btn_ingreso"
                                    href="https://web.icetex.gov.co/login-Integracion"
                                    type="button"
                                    id="buttonIcetex"
                                >
                                    Ingresa a ICETEX virtual
                                </a>
                            </Grid>
                            <Grid
                                item
                                xs={6}
                                sm={6}
                                md={6}
                                className="container-logo-icetex"
                            >
                                <a
                                    className="logo custom-logo align-items-center"
                                    href="https://web.icetex.gov.co"
                                    title="Ir a ICETEX"
                                    id="logoIcetex"
                                >
                                    <img
                                        alt="ICETEX"
                                        height="50"
                                        className="logo-icetex"
                                    />
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default HeaderIcetex;
